import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Proteins } from 'models/Pet'
import { FrozenRecipeDetail } from 'features/Recipes/FrozenRecipeDetail'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    name: 'Venison Patty Recipe',
    description:
      "Our venison is sourced from Australia. A delicious and novel recipe that's complete and balanced for dogs of all life stages. Formulated by a PhD nutritionist.",
    image: 'https://wefeedraw.com/assets/recipes/categories/individual/hero-venison.webp',
    author: {
      '@type': 'Organization',
      name: 'We Feed Raw'
    },
    publisher: {
      '@type': 'Organization',
      name: 'We Feed Raw',
      logo: {
        '@type': 'ImageObject',
        url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
      }
    },
    recipeCategory: 'Raw Dog Food',
    recipeCuisine: 'Pet Food',
    prepTime: 'PT1M',
    cookTime: 'PT0M',
    recipeYield: 'Yield varies based on the size and dietary needs of your dog',
    keywords: 'raw dog food venison',
    recipeIngredient: [
      'Venison',
      'Beef Heart',
      'Beef Liver',
      'Beef Kidney',
      'Beef Necks (with bone)',
      'WFR vitamin + mineral mix'
    ],
    nutrition: {
      '@type': 'NutritionInformation',
      calories: '51 kcal M.E./oz',
      proteinContent: '(min) 13.0%',
      fatContent: '(min) 10.7%',
      fiberContent: '(max) 1.0%',
      additionalProperty: [
        {
          '@type': 'PropertyValue',
          name: 'Calories per kg',
          value: '1450 kcal M.E./kg'
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:VENISON.page-title')}</title>
        <meta name="title" content={t('recipes:VENISON.meta-title')} />
        <meta name="description" content={t('recipes:recipe-detail-meta-description', { protein: Proteins.VENISON.toLowerCase() })} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/venison" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FrozenRecipeDetail protein={Proteins.VENISON} />
      </main>
    </div>
  )
}
